export const accountingsActions = {
  fetchPostedByDate: (payload) => ({
    type: 'accountings.posted.fetch',
    payload,
  }),
  fetchPostedByDateSuccess: (payload) => ({
    type: 'accountings.posted.success',
    payload,
  }),
  fetchPostedbyDateFailure: (payload) => ({
    type: 'accountings.posted.failure',
    payload,
  }),
  fetchTempByDate: (payload) => ({
    type: 'accountings.temp.fetch',
    payload,
  }),
  fetchTempByDateSuccess: (payload) => ({
    type: 'accountings.temp.success',
    payload,
  }),
  fetchTempbyDateFailure: (payload) => ({
    type: 'accountings.temp.failure',
    payload,
  }),
  fetchPostedSlaughterList: (payload) => ({
    type: 'accountings.posted.slaughterList.fetch',
    payload,
  }),
  fetchPostedSlaughterListSuccess: (payload) => ({
    type: 'accountings.posted.slaughterList.success',
    payload,
  }),
  fetchPostedSlaughterListFailure: (payload) => ({
    type: 'accountings.posted.slaughterList.failure',
    payload,
  }),
  fetchTempSlaughterList: (payload) => ({
    type: 'accountings.temp.slaughterList.fetch',
    payload,
  }),
  fetchTempSlaughterListSuccess: (payload) => ({
    type: 'accountings.temp.slaughterDates.success',
    payload,
  }),
  fetchTempSlaughterListFailure: (payload) => ({
    type: 'accountings.temp.slaughterDates.failure',
    payload,
  }),
  fetchDocuments: () => ({
    type: 'accountings.documents.fetch',
  }),
  fetchDocumentsSuccess: (payload) => ({
    type: 'accountings.documents.success',
    payload,
  }),
  fetchDocumentsFailure: (payload) => ({
    type: 'accountings.documents.failure',
    payload,
  }),

  fetchDashboardStatistics: () => ({
    type: 'accountings.statistics.dshboard.fetch',
  }),
  fetchDashboardStatisticsSuccess: (payload) => ({
    type: 'accountings.statistics.dashboard.success',
    payload,
  }),
  fetchDashboardStatisticsFailure: (payload) => ({
    type: 'accountings.statistics.dashboard.failure',
    payload,
  }),

  fetchFarmerStatistics: (payload) => ({
    type: 'accountings.statistics.fetch',
    payload,
  }),
  fetchFarmerStatisticsSuccess: (payload) => ({
    type: 'accountings.statistics.success',
    payload,
  }),
  fetchFarmerStatisticsFailure: (payload) => ({
    type: 'accountings.statistics.failure',
    payload,
  }),

  fetchAllFarmerStatistics: (payload) => ({
    type: 'accountings.statistics.all.fetch',
    payload: { ...payload, fetchAll: true },
  }),
  fetchAllFarmerStatisticsSuccess: (payload) => ({
    type: 'accountings.statistics.all.success',
    payload,
  }),
  fetchAllFarmerStatisticsFailure: (payload) => ({
    type: 'accountings.statistics.all.failure',
    payload,
  }),

  fetchSlaughterhouseStatistics: () => ({
    type: 'accountings.statisticsslaughterhouse.fetch',
  }),
  fetchSlaughterhouseStatisticsSuccess: (payload) => ({
    type: 'accountings.statistics.slaughterhouse.success',
    payload,
  }),
  fetchSlaughterhouseStatisticsFailure: (payload) => ({
    type: 'accountings.statistics.slaughterhouse.failure',
    payload,
  }),

  fetchAnimalKindsWithStats: (payload) => ({
    type: 'accountings.statistics.animalKeepingWithStats.fetch',
    payload,
  }),
  fetchAnimalKindsWithStatsSuccess: (payload) => ({
    type: 'accountings.statistics.animalKeepingWithStats.success',
    payload,
  }),
  fetchAnimalKindsWithStatsFailure: (payload) => ({
    type: 'accountings.statistics.animalKeepingWithStats.failure',
    payload,
  }),
};
